module.exports = __webpack_public_path__ + "static/media/spicytuna.8a8419de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/spicytuna.jpg
// module id = 114
// module chunks = 0